export async function fetchLatestNews(opts = {}) {
  const { signal } = opts;
  const res = await fetch("/api/news/latest", { method: "GET", signal });
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
  const data = await res.json();
  const news = data?.news;
  return Array.isArray(news) ? news : [];
}
